// Localização: src/components/Common/LoadingIndicator.js

import React from 'react';
import { Loader } from 'lucide-react'; // Ícone do Lucide

const LoadingIndicator = ({ message = 'Carregando dados, por favor aguarde...' }) => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
            <div className="flex flex-col items-center p-8 bg-white rounded-xl shadow-lg border border-gray-100">
                
                {/* Ícone de Carregamento com animação de giro */}
                <Loader 
                    size={40} 
                    className="animate-spin text-teal-600 mb-4" 
                    aria-label="Carregando"
                />
                
                {/* Mensagem */}
                <p className="text-lg font-semibold text-gray-700 mb-2">
                    Aguarde
                </p>
                <p className="text-sm text-gray-500 text-center max-w-xs">
                    {message}
                </p>
            </div>
        </div>
    );
};

export default LoadingIndicator;